export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6736.3abbf436.jpg";